module.exports = {"370724001":"城关街道","370724002":"东城街道","370724101":"五井镇","370724103":"冶源镇","370724104":"寺头镇","370724105":"九山镇","370724107":"辛寨镇","370724112":"山旺镇","370724113":"柳山镇","370724116":"蒋峪镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370724.json
// module id = 1416
// module chunks = 0